module.exports = __webpack_public_path__ + "media/images/icons/twotone/credit-card-626a4705f40a258ec49d651eb5c15d5a.svg";